import { currencyFormat, dateFormat } from '../utils/formatter';
import useDateRangeCol from './useDateRangeCol';

const useCustomerInvoiceCols = () => {
  const transDateCol = useDateRangeCol('TRANS_DATE', 'Trans Date');
  const dueDateCol = useDateRangeCol('DUE_DATE', 'Due Date');

  const customerInvoiceCols = [
    {
      accessorKey: 'TRANS_TYPE',
      header: 'Trans Type',
      filterFn: 'contains',
    },
    {
      accessorKey: 'INVOICE',
      header: 'Invoice',
      filterFn: 'contains',
    },
    {
      accessorKey: 'PAYMENT_SEQ',
      header: 'Payment Seq',
      filterFn: 'contains',
    },
    {
      accessorKey: 'STATUS',
      header: 'Status',
      filterFn: 'contains',
    },
    {
      accessorKey: 'CUST_PO_NBR',
      header: 'Cust Po Nbr',
      enableSorting: true,
      enableColumnFilter: false,
      size: 1,
    },
    transDateCol,
    dueDateCol,
    {
      accessorKey: 'TRAN_AMT',
      header: 'Tran Amount',
      filterFn: 'contains',
      enableSorting: true,
      Cell: ({ cell }) => currencyFormat(cell.getValue()),
    },
    {
      accessorKey: 'APPLD_AMT',
      header: 'Applied Amount',
      filterFn: 'contains',
      enableSorting: true,
      Cell: ({ cell }) => currencyFormat(cell.getValue()),
    },
    {
      accessorKey: 'OPEN_AMT',
      header: 'Open Amount',
      filterFn: 'contains',
      enableSorting: true,
      Cell: ({ cell }) => currencyFormat(cell.getValue()),
    },
    {
      accessorKey: 'PAYMENT_VIEW',
      header: 'Payment',
    },
    {
      accessorKey: 'DISTRIB_VIEW',
      header: 'Distrib'
    }
  ];

  return customerInvoiceCols;
};



export const arInvoiceCols = [
  {
    accessorKey: 'INVOICE_NUMBER',
    header: 'Invoice',
    filterFn: 'contains'
  },
  {
    accessorKey: 'INVOICE_DATE',
    header: 'Date',
    filterFn: 'contains',
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'ORDER_NBR',
    header: 'Order Number',
    filterFn: 'contains'
  },
  {
    accessorKey: 'LINE_AMT_TOT',
    header: 'Amount',
    filterFn: 'contains',
    muiTableHeadCellProps: {
      align: 'right',
    },
    Cell: ({ cell }) => currencyFormat(cell.getValue()),
    muiTableBodyCellProps: {
      align: 'right',
    },
  },
  {
    accessorKey: 'VIEW',
    header: 'View',
    enableSorting: false,
    enableColumnFilter: false,
    muiTableBodyCellProps: {
      align: 'center',
    },
    muiTableHeadCellProps: {
      align: 'center',
    },
  },
];


export { useCustomerInvoiceCols };
